import {
  Box,
  Typography,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export function WSPUrlLinkFields({ localNodeData, updateNodeData }) {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        URL *
      </Typography>
      <TextField
        value={localNodeData.url || ''}
        size="small"
        fullWidth
        onChange={(e) => updateNodeData('url', e.target.value)}
      />

      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1, mt: 2 }}>
        Texto del botón * (máx. 20 caracteres)
      </Typography>
      <TextField
        value={localNodeData.displayText || ''}
        size="small"
        fullWidth
        inputProps={{ maxLength: 20 }}
        onChange={(e) => updateNodeData('displayText', e.target.value)}
      />

      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1, mt: 2 }}>
        Texto del cuerpo * (máx. 1024 caracteres)
      </Typography>
      <TextField
        value={localNodeData.bodyText || ''}
        size="small"
        fullWidth
        multiline
        rows={3}
        inputProps={{ maxLength: 1024 }}
        onChange={(e) => updateNodeData('bodyText', e.target.value)}
      />

      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Header (opcional)</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <Select
              value={localNodeData.headerType || ''}
              onChange={(e) => updateNodeData('headerType', e.target.value)}
              displayEmpty
            >
              <MenuItem value="">Sin header</MenuItem>
              <MenuItem value="text">Texto</MenuItem>
              <MenuItem value="image">Imagen</MenuItem>
              <MenuItem value="video">Video</MenuItem>
              <MenuItem value="document">Documento</MenuItem>
            </Select>
          </FormControl>

          {localNodeData.headerType === 'text' && (
            <TextField
              label="Texto del header (máx. 60 caracteres)"
              value={localNodeData.headerText || ''}
              size="small"
              fullWidth
              inputProps={{ maxLength: 60 }}
              onChange={(e) => updateNodeData('headerText', e.target.value)}
            />
          )}

          {localNodeData.headerType === 'image' && (
            <TextField
              label="URL de la imagen"
              value={localNodeData.headerImageUrl || ''}
              size="small"
              fullWidth
              onChange={(e) => updateNodeData('headerImageUrl', e.target.value)}
            />
          )}

          {localNodeData.headerType === 'video' && (
            <TextField
              label="URL del video"
              value={localNodeData.headerVideoUrl || ''}
              size="small"
              fullWidth
              onChange={(e) => updateNodeData('headerVideoUrl', e.target.value)}
            />
          )}

          {localNodeData.headerType === 'document' && (
            <TextField
              label="URL del documento"
              value={localNodeData.headerDocumentUrl || ''}
              size="small"
              fullWidth
              onChange={(e) => updateNodeData('headerDocumentUrl', e.target.value)}
            />
          )}
        </AccordionDetails>
      </Accordion>

      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1, mt: 2 }}>
        Texto del footer (opcional, máx. 60 caracteres)
      </Typography>
      <TextField
        value={localNodeData.footerText || ''}
        size="small"
        fullWidth
        inputProps={{ maxLength: 60 }}
        onChange={(e) => updateNodeData('footerText', e.target.value)}
      />
    </Box>
  );
}